// extracted by mini-css-extract-plugin
export default {"Blink":"DotDotDot_Blink__ZrmUP","blink":"DotDotDot_blink__Ic6Ah"};